
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import Link from 'components/Link'
import SlideContainer from 'components/SlideContainer'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {
  getCostConnectorInfo,
  getChannelWithCostConnector
} from 'redux/modules/integrations/selectors'
import {connect} from 'react-redux'

export class IntegrationAddView extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    channelId: PropTypes.string,
    channelGroupId: PropTypes.string,
    costConnector: PropTypes.object,
    costConnectorInfo: PropTypes.object.isRequired
  }

  render() {
    const {closeModal} = this.props

    return (
      <SlideContainer
        className='integration-add-view'
        width={720}
      >
        <div className='integration-add-view_container'>
          {this.renderInfo()}
          <div className='integration-add-view_main-column'>
            {this.renderHeader()}
            {this.renderContent()}
            <Icon
              className='integration-add-view_close-icon'
              name='cross'
              size='25px'
              onClick={closeModal}
            />
          </div>
        </div>
      </SlideContainer>
    )
  }

  renderInfo() {
    const {channelGroupId, channelId, costConnector, closeModal, costConnectorInfo} = this.props
    const {icon} = costConnectorInfo
    const hasAuth = costConnector ? costConnector.auth : null
    return (
      <div className='integration-add-view_info'>
        <div className='integration-add-view_info_icon'>
          <Icon
            className='integration-add-view_channel-icon'
            name={`channel-${icon}`}
            size='77px'
          />
        </div>
        <Link
          to={`/settings/integrations/${channelGroupId}/${channelId}`}
          className='integration-add-view_info_action button is-blue'
          onClick={() => closeModal()}
        >
          {hasAuth ? 'Show' : 'Connect'}
        </Link>
        <div className='integration-add-view_content'>
          <h3>Useful Links</h3>
          <ul>
            <li><a href={this.renderWebsite()} target='_blank'>Visit website</a></li>
          </ul>
        </div>
      </div>
    )
  }

  renderWebsite() {
    const {costConnectorInfo: {costConnectorType}} = this.props

    if (costConnectorType === 'adwords') {
      return 'https://www.google.com/adwords/'
    } else if (costConnectorType === 'facebook') {
      return 'https://www.facebook.com/business/products/ads/'
    } else if (costConnectorType === 'bing') {
      return 'https://secure.bingads.microsoft.com/'
    }
  }

  renderHeader() {
    const {costConnectorInfo: {title, description}} = this.props

    return (
      <div className='integration-add-view_header'>
        <div className='integration-add-view_title'>{title}</div>
        <div className='integration-add-view_description'>{description}</div>
      </div>
    )
  }

  renderContent() {
    const {costConnectorInfo: {costConnectorType}} = this.props

    if (costConnectorType === 'adwords') {
      return (
        <div className='integration-add-view_main-content integration-add-view_content'>
          <p>
            Google Adwords lets you be seen by customers at the very moment
             that they’re searching on Google for the things you offer.
             You only pay when they click to visit your website or call.
          </p>
          <h2>
            Integrations details
          </h2>
          <p>
            The Google Adwords integration automatically syncs to import your
             cost data once per day. Getting your marketing cost data into
             Data-Driven allows for more detailed reports and to calculate KPIs
             such as Customer Acquisition Cost, Cost/Visit and Marketing ROI.
          </p>
        </div>
      )
    } else if (costConnectorType === 'facebook') {
      return (
        <div className='integration-add-view_main-content integration-add-view_content'>
          <p>
            With Facebook Adverts, you can create targeted adverts to reach
             different audiences and meet your business goals.
          </p>
          <h2>
            Integrations details
          </h2>
          <p>
            The Facebook Ads integration automatically syncs to import your
             cost data once per day. Getting your marketing cost data into
             Data-Driven allows for more detailed reports and to calculate KPIs such
             as Customer Acquisition Cost, Cost/visit and Marketing ROI.
          </p>
        </div>
      )
    } else if (costConnectorType === 'bing') {
      return (
        <div className='integration-add-view_main-content integration-add-view_content'>
          <p>
            With Bing Adverts, you can create targeted adverts to reach
             different audiences and meet your business goals.
          </p>
          <h2>
            Integrations details
          </h2>
          <p>
            The Bing Ads integration automatically syncs to import your
             cost data once per day. Getting your marketing cost data into
             Data-Driven allows for more detailed reports and to calculate KPIs such
             as Customer Acquisition Cost, Cost/visit and Marketing ROI.
          </p>
        </div>
      )
    }
  }
}

const mapStateToProps = (state, props) => {
  const {channelGroupId, channelId} = props

  return {
    costConnector: getChannelWithCostConnector(state, channelGroupId, channelId),
    costConnectorInfo: getCostConnectorInfo(channelGroupId, channelId)
  }
}

const mapDispatchToProps = {
  closeModal
}

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationAddView)



// WEBPACK FOOTER //
// ./client/modals/IntegrationAddView/index.js